import { TranslateService } from '@ngx-translate/core';
import { userService } from './../../Services/userService';
import { MotorStatusMdl } from './../../Models/MotorStatusMdl';
import { Component, ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { loginRes } from '../../Models/loginRes';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../Services/languageService';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { restURL } from '../../Models/restURL';
import { loginReq } from '../../Models/loginReq';
import { forgetPassReqMdl } from '../../Models/forgetPassReqMdl';
import { userinfo } from '../../Services/userinfo';
import * as CryptoJS from 'crypto-js';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RegistrationMdl } from '../../Models/RegistrationMdl';
import { OtpVerifyReq } from '../../Models/OtpVerifyReq';
import { OtpVerifyRes } from '../../Models/OtpVerifyRes';
import Swal from 'sweetalert2';
import { mdlGetMobileNoRes } from '../../Models/mdlGetMobileNoRes';
import { mdlVerifyDetails_UpdateMobileNoReq } from '../../Models/mdlVerifyDetails_UpdateMobileNoReq';
import * as $ from 'jquery';
import { motorProposalService } from '../../Services/motorProposalService';
import { mdlPayloadRequest } from '../../Models/mdlPayloadRequest';
import { mdlPayloadResponse } from '../../Models/mdlPayloadResponse';
import { ResendOTPMdl } from '../../Models/ResendOTPMdl';
import { mdlGetMobilenoVerificationRes } from '../../Models/mdlGetMobilenoVerificationRes';

@Component({
  selector: 'Login',
  templateUrl: './Login.html',
  styleUrls: ['./Login.css']
})
export class Login {
  public loginStObj: loginRes = new loginRes();
  public fgObj: forgetPassReqMdl = new forgetPassReqMdl();
  public HasForgot: boolean;
  public apiUrl: restURL = new restURL();
  public showLoading: boolean = false;
  public loginReqObj: loginReq = new loginReq();
  public st: MotorStatusMdl = new MotorStatusMdl();
  public Lng: string;
  public objGetMobileNoRes: mdlGetMobileNoRes = new mdlGetMobileNoRes();
  public otpReq: OtpVerifyReq = new OtpVerifyReq();
  public otpRes: OtpVerifyRes = new OtpVerifyRes();
  public objmdlVerifyDetailsReq: mdlVerifyDetails_UpdateMobileNoReq = new mdlVerifyDetails_UpdateMobileNoReq();
  public forgetMobile: string;
  public OldMobileNumber: string;
  public GetMobileNumber: boolean = false;
  public NewMobileNumber: boolean = false;
  public DisableProceed: boolean = true;
  public ClickHere: boolean = true;
  public IdExpiry: boolean = false;
  public MM: string;
  public YY: string;
  public isUpdate: boolean = false;
  public isOTP: boolean = false;
  public OTPorChange: boolean = false;
  public ShowTimer: boolean = false;
  public timeLeft: number = 180;
  public interval;
  public isResendShow: boolean = false;
  public isLockFields: boolean = false;
  public OTP: string;
  public LngSubscription: Subscription;
  public show: boolean = false;
  public ShowForgotPassowrd: boolean = false;
  public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
  public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
  public showOTP: boolean = false;
  public isShowTimer: boolean = false;
  public RemainTime: number;
  public counter: number = 0;
  public resendObj: ResendOTPMdl = new ResendOTPMdl();
  public YakeenMobileres:mdlGetMobilenoVerificationRes=new mdlGetMobilenoVerificationRes();
  @ViewChild('closeBtn') closeBtn: ElementRef;

  constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private userInfo: userService, private translate: TranslateService, public toastr: ToastsManager, vcr: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vcr);
    this.fgObj.IqamaNo = "";

    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    if (sessionStorage.getItem("ForgotPassword") == "TRUE") {
      this.ShowForgotPassowrdModal();
      sessionStorage.setItem("ForgotPassword", "False");
    }

    this.showOTP = false;
    this.showLoading = false;
    this.isResendShow = false;
    this.RemainTime = 180;
    this.isShowTimer = false;
  }

  ShowForgotPassowrdModal() {
    this.ShowForgotPassowrd = true;
  }

  TogglePassword() {
    this.show = !this.show;
  }

  Forgot() {
    this.HasForgot = true;
  }

  forgetPass() {

    this.showLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.fgObj));

    //this.http.post<MotorStatusMdl>(this.apiUrl.baseURL + "/Registration/ForgetPassword", this.fgObj, this.userInfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "/Registration/ForgetPassword", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      Swal("Info", this.translate.instant(this.st.StatusDesc), "info");
      this.showLoading = false;
      this.fgObj.IqamaNo = "";
      this.closeBtn.nativeElement.click();
    }, (error) => {

      this.showLoading = false;
    });
  }

  async  login(val) {
    if (!val) {
      Swal("Info", this.translate.instant("Please Fill All Mandatory Fields"), "info");
      return;
    }
    var passKey = this.loginReqObj.IqamaNo + this.apiUrl.key;
    var key = CryptoJS.enc.Utf8.parse(passKey);
    var iv = CryptoJS.enc.Utf8.parse(passKey);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(this.loginReqObj.Password), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    this.loginReqObj.Password = encrypted.toString();
    this.showLoading = true;


    // await this.http.get('https://api.ipify.org/?format=json').toPromise().then(
    //   (result) => {
    //     this.loginReqObj.IpAddress = JSON.parse(JSON.stringify(result)).ip;
    //   }, (error) => { }
    // );

    this.http.get('https://api.ipify.org/?format=json').toPromise().then(
      (result) => {
        this.loginReqObj.IpAddress = JSON.parse(JSON.stringify(result)).ip;
      }, (error) => { }
    );





    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.loginReqObj));

    this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "/Registration/Login", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {

      this.showLoading = false;
      //New Line Start
      this.objPayloadResponse = result;
      this.loginStObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      if (this.loginStObj.st.StatusCode === "S") {


        Swal({
          title: this.translate.instant(this.loginStObj.st.StatusDesc),
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          showCloseButton: true,
          timer: 3000
        })
        this.isLockFields = true;
        this.showOTP = true;
        this.showOTPTimer();
        // this.userInfo.setToken(this.loginStObj.token);
        // sessionStorage.setItem("IqamaNo", this.loginStObj.IqamaNo);
        sessionStorage.setItem("RegNo", this.loginStObj.RegNo.toString());
        // sessionStorage.setItem("Lng", this.loginStObj.Lng);
        // sessionStorage.setItem("Language", this.loginStObj.Lng);
        // sessionStorage.setItem("InsuredName", this.loginStObj.Name);
        // sessionStorage.setItem("InsuredNameAr", this.loginStObj.NameAr);
        // sessionStorage.setItem("NameAr", this.loginStObj.NameAr);
        // sessionStorage.setItem("NatEn", this.loginStObj.Nationality);
        // sessionStorage.setItem("NatAr", this.loginStObj.NationalityAr);
        // sessionStorage.setItem("InsuredToken", this.loginStObj.Insuredtoken);

        // if (sessionStorage.getItem("Language") == 'en') {
        //   this.translate.currentLang = "en";
        //   $("body").removeClass("Arabic");
        //   this.lngService.setLng("en")
        //   this.translate.setDefaultLang("en")
        // }
        // else if (sessionStorage.getItem("Language") == 'ar') {
        //   this.translate.currentLang = "ar";
        //   this.lngService.setLng("ar")
        //   $("body").addClass("Arabic");
        //   this.translate.setDefaultLang("ar");
        // }
        // sessionStorage.setItem("LoginSuccess", "TRUE");
        // sessionStorage.setItem("CurrentRoute", "Welcome");
        // sessionStorage.setItem("Policy", "True");
        // this.router.navigate(['/NewDashboard/Policy']);
      }
      else {
        this.ShowErrorMessage();
        this.loginReqObj.Password = '';
      }


    }, (error) => {

      this.showLoading = false;
      Swal("Error", this.translate.instant(error), "error")
    });
  }

  ShowErrorMessage() {

    Swal("Error", this.translate.instant(this.loginStObj.st.StatusDesc), "error");

    if (this.loginStObj.st.StatusDesc.includes('1')) {
      this.toastr.error(this.translate.instant("Remaining Attempts: 1"), this.translate.instant('Oops!'), { showCloseButton: true });
    }
    else if (this.loginStObj.st.StatusDesc.includes('2')) {
      this.toastr.error(this.translate.instant("Remaining Attempts: 2"), this.translate.instant('Oops!'), { showCloseButton: true });
    }
    else if (this.loginStObj.st.StatusDesc.includes('3')) {
      this.toastr.error(this.translate.instant("Remaining Attempts: 3"), this.translate.instant('Oops!'), { showCloseButton: true });
    }
    else if (this.loginStObj.st.StatusDesc.includes('4')) {
      this.toastr.error(this.translate.instant("Remaining Attempts: 4"), this.translate.instant('Oops!'), { showCloseButton: true });
    }
    else if (this.loginStObj.st.StatusDesc.includes('5')) {
      this.toastr.error(this.translate.instant("Remaining Attempts: 5"), this.translate.instant('Oops!'), { showCloseButton: true });
    }
    else {
      this.toastr.error(this.translate.instant("Remaining Attempts: 0"), this.translate.instant('Oops!'), { showCloseButton: true });
    }

    // } else {

    //   Swal("Error", this.translate.instant(this.loginStObj.st.StatusDescAr), "error");
    //   if (this.loginStObj.st.StatusDesc.includes('1')) {
    //     this.toastr.error(this.translate.instant("Remaining Attempts: 1"), 'Oops!', { showCloseButton: true });
    //   }
    //   else if (this.loginStObj.st.StatusDesc.includes('2')) {
    //     this.toastr.error("Remaining Attempts: 2", 'Oops!', { showCloseButton: true });
    //   }
    //   else if (this.loginStObj.st.StatusDesc.includes('3')) {
    //     this.toastr.error("Remaining Attempts: 3", 'Oops!', { showCloseButton: true });
    //   }
    //   else if (this.loginStObj.st.StatusDesc.includes('4')) {
    //     this.toastr.error("Remaining Attempts: 4", 'Oops!', { showCloseButton: true });
    //   }
    //   else if (this.loginStObj.st.StatusDesc.includes('5')) {
    //     this.toastr.error("Remaining Attempts: 5", 'Oops!', { showCloseButton: true });
    //   }
    //   else {
    //     this.toastr.error("Remaining Attempts: 0", 'Oops!', { showCloseButton: true });
    //   }
    // }
  }

  GetMobileNo(valid) {
    // if (!valid) {
    //   return;
    // }
    if (this.fgObj.IqamaNo.length == 0) {
      this.GetMobileNumber = false;
      this.ClearFields();
      //this.Lng == "ar" ? Swal("برجاء إدخال رقم الهوية", "Info", "warning") : Swal("Please Enter ID Number", "Info", "warning");
      Swal(this.translate.instant("Please Enter ID Number"), "Info", "warning");
      return;
    }
    else if (this.fgObj.IqamaNo.length != 10) {
      this.GetMobileNumber = false;
      this.ClearFields();
    }

    if (this.fgObj.IqamaNo.length == 10) {
      this.showLoading = true;

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.fgObj));

      //this.http.post<mdlGetMobileNoRes>(this.apiUrl.baseURL + "/Registration/GetMobileNo", this.fgObj, this.userInfo.getHttpOptions()).toPromise().then((result) => {
      this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "/Registration/GetMobileNo", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        //this.objGetMobileNoRes = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.objGetMobileNoRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End


        this.showLoading = false;

        if (this.objGetMobileNoRes.StatusCode == "S") {
          this.GetMobileNumber = true;
          this.DisableProceed = false;
          this.OldMobileNumber = "05XXXX" + this.objGetMobileNoRes.MobileNo.substring(5);
        }
        else {
          this.DisableProceed = true;
          this.GetMobileNumber = false;
          // if (this.Lng == 'en') {
          //   Swal(this.objGetMobileNoRes.StatusDescEn, "Info", "warning");
          // }
          // else {
          //   Swal(this.objGetMobileNoRes.StatusDescAr, "Info", "warning");
          // }
          Swal(this.translate.instant(this.objGetMobileNoRes.StatusDescEn), "Info", "warning");

        }

      }, (error) => {
        this.showLoading = false;
        Swal(this.translate.instant("Please try again later"));
      });

    }
  }

  UpdateMobile(valid) {

    this.isUpdate = true;
    if (valid) {

      if (this.objGetMobileNoRes.MobileNo == this.objmdlVerifyDetailsReq.NewMobileNo.substring(1)) {
        this.Lng == "ar" ? Swal("رقم الجوال يجب ألا يكون نفس الرقم القديم", "Info", "warning") : Swal("Mobile No Should Not Be Old MobileNo", "Info", "warning");
        return;
      }


      this.objmdlVerifyDetailsReq.RegNo = this.objGetMobileNoRes.RegNo;
      this.objmdlVerifyDetailsReq.InsuredIdNo = this.fgObj.IqamaNo;
      this.objmdlVerifyDetailsReq.Lng = this.Lng;
      if (this.fgObj.IqamaNo.charAt(0) == "1") {
        this.objmdlVerifyDetailsReq.IDExpiry = this.MM + "-" + this.YY;
      } else if (this.fgObj.IqamaNo.charAt(0) == "2") {
        this.objmdlVerifyDetailsReq.DOB = this.MM + "-" + this.YY;
      }

      this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlVerifyDetailsReq));

      //this.http.post<MotorStatusMdl>(this.apiUrl.baseURL + "/Registration/VerifyDetails_UpdateMobileNo", this.objmdlVerifyDetailsReq, this.userInfo.getHttpOptions()).toPromise().then((result) => {
      this.http.post<mdlPayloadResponse>(this.apiUrl.baseURL + "/Registration/VerifyDetails_UpdateMobileNo", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
        //this.st = result;

        //New Line Start
        this.objPayloadResponse = result;
        this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
        //NewLine End

        if (this.st.StatusCode === "S") {
          this.Lng == "ar" ? Swal("تم إرسال رمز التفعيل إلى رقم الجوال الجديد، برجاء التحقق", "success", "success") : Swal("OTP Sent successfully to your New Mobile Number Please Verify", "success", "success");
          this.isLockFields = true;
          this.isOTP = true;
          this.showOTPTimer();
          this.ShowTimer = true;
        }
        else {
          this.Lng == "ar" ? Swal(this.st.StatusDescAr, "Info", "warning") : Swal(this.st.StatusDesc, "Info", "warning");
          return;

        }
      }, (error) => {
        this.showLoading = false;
        Swal("Please Try agian later.");

      });


    }
  }

  showOTPTimer() {
    this.isShowTimer = true;
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else if (this.timeLeft == 0) {
        this.timeLeft = 0;
        this.isResendShow = true;
      } else {
        this.timeLeft = 180;
      }
    }, 1000)
  }

  VerifyOTP() {
    this.objmdlVerifyDetailsReq.OTP = this.OTP;
    this.OTP = "";
    this.showLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlVerifyDetailsReq));

    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/VerifyOtp_UpdateMobileNo", this.objmdlVerifyDetailsReq, this.userInfo.getHttpOptions()).toPromise().then(result => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/VerifyOtp_UpdateMobileNo", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End


      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);

      if (this.st.StatusCode === "S") {
        this.HideForgotPassword()
      } else {
        if (this.st.Result === "E") {
          clearInterval(this.interval);
          this.timeLeft = 180;
          this.ShowTimer = true;
          this.showOTPTimer();
        }

      }
      this.showLoading = false;
    }, (error) => {
      this.showLoading = false;
      Swal("Please Try agian later.");
    });
  }

  ResendOTP() {
    this.showLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlVerifyDetailsReq));
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "/Registration/ResendOTP_UpdateMobileNo", this.objmdlVerifyDetailsReq, this.userInfo.getHttpOptions()).toPromise().then((result) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Registration/ResendOTP_UpdateMobileNo", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
      //this.st = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.showLoading = false;
      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);
      if (this.st.StatusCode == "S") {
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.isResendShow = false;
        this.showOTPTimer();
      }
    }, (error) => {
      Swal("Try agian");
      this.showLoading = false;
    });

  }

  HideForgotPassword() {
    this.fgObj.IqamaNo = '';
    this.GetMobileNumber = false;
    this.NewMobileNumber = false;
    this.DisableProceed = true;
    this.isOTP = false;
    this.objmdlVerifyDetailsReq.NewMobileNo = '';
    this.MM = '';
    this.YY = '';
    this.isLockFields = false;
    this.OTPorChange = false;
    this.isResendShow = false;
    this.OTP = "";
    clearInterval(this.interval);
    this.timeLeft = 180;
    this.ShowForgotPassowrd = false;
  }

  ClearFields() {
    this.GetMobileNumber = false;
    this.NewMobileNumber = false;
    this.DisableProceed = true;
    this.isOTP = false;
    this.objmdlVerifyDetailsReq.NewMobileNo = '';
    this.MM = '';
    this.YY = '';
    this.isLockFields = false;
    this.OTPorChange = false;
    this.isResendShow = false;
    this.OTP = '';
  }

  ChangeMobileNumber() {
    this.GetMobileNumber = false;
    this.DisableProceed = true;
    this.IdExpiry = true;
    this.NewMobileNumber = true;
    this.OTPorChange = true;
  }

  ValidateSpecialChar(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 67) || (k > 67 && k < 91) || (k > 96 && k < 99) || (k > 99 && k < 118) || (k > 118 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  LoginVerifyOTP() {

    this.otpReq.RegNo = Number(sessionStorage.getItem("RegNo"));

    this.showLoading = true;

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.otpReq));

    //this.http.post<OtpVerifyRes>(this.url.baseURL + "Registration/VerifyOTP", this.otpReq, this.userInfo.getHttpOptions()).toPromise().then(result => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/LoginVerifyOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then(result => {
      //this.otpRes = result;

      //New Line Start
      this.objPayloadResponse = result;
      this.otpRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      // Swal(this.translate.instant(this.otpRes.st.StatusDesc));
      Swal({
        title: this.translate.instant(this.otpRes.st.StatusDesc),
        text: '',
        type: (this.otpRes.st.StatusCode == "S" ? 'success' : 'warning'),
        // showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showCloseButton: true,
        timer: 5000
      })
      if (this.otpRes.st.StatusCode === "S") {
        //alert(this.loginStObj.token);   
        this.userInfo.setToken(this.otpRes.token);
        sessionStorage.setItem("IqamaNo", this.otpRes.IqamaNo);
        sessionStorage.setItem("RegNo", this.otpRes.Regno.toString());
        sessionStorage.setItem("Lng", this.otpRes.Lng);
        sessionStorage.setItem("Language", this.otpRes.Lng);
        sessionStorage.setItem("InsuredName", this.otpRes.InsuredName);
        sessionStorage.setItem("InsuredNameAr", this.otpRes.InsuredNameAr);
        sessionStorage.setItem("NameAr", this.otpRes.InsuredNameAr);
        sessionStorage.setItem("NatEn", this.otpRes.Nationality);
        sessionStorage.setItem("NatAr", this.otpRes.NationalityAr);
        sessionStorage.setItem("InsuredToken", this.otpRes.Insuredtoken);
        

        if (sessionStorage.getItem("Language") == 'en') {
          this.translate.currentLang = "en";
          $("body").removeClass("Arabic");
          this.lngService.setLng("en")
          this.translate.setDefaultLang("en")
        }
        else if (sessionStorage.getItem("Language") == 'ar') {
          this.translate.currentLang = "ar";
          this.lngService.setLng("ar")
          $("body").addClass("Arabic");
          this.translate.setDefaultLang("ar");
        }
        sessionStorage.setItem("LoginSuccess", "TRUE");
        sessionStorage.setItem("CurrentRoute", "Welcome");
        sessionStorage.setItem("Policy", "True");

        this.router.navigate(['/NewDashboard/Policy']);
      }
      else {
        if (this.otpRes.st.Result === "E") {
          this.isShowTimer = true;
          this.timeLeft = 0;
          this.isResendShow = true;
          this.showOTPTimer();
        }
        else if (this.otpRes.st.Result === "5A") {
          this.showOTP = false;
          this.isShowTimer = false;
        }
      }
      this.showLoading = false;
    }, (error) => {
      this.showLoading = false;
      Swal(this.translate.instant("Please Try agian later."));
    });
  }

  LoginResendOTP() {

    this.counter += 1;
    if (this.counter > 5) {
      Swal(this.translate.instant("Maximum resend attempts reached. Please try again later"));
      return;
    }
    //alert("Test");
    this.resendObj.RegNo = sessionStorage.getItem("RegNo");

    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.resendObj));
    this.showLoading = true;
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "Registration/ResendOTP", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((res) => {
      //this.st = res;

      //New Line Start
      this.objPayloadResponse = res;
      this.st = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

      this.Lng == "ar" ? Swal(this.st.StatusDescAr) : Swal(this.st.StatusDesc);
      if (this.st.StatusCode == "S") {
        clearInterval(this.interval);
        this.timeLeft = 180;
        this.showOTPTimer();
        this.isResendShow = false;

      }
      this.showLoading = false;
    }, (res) => {
      Swal("Try agian");
      this.showLoading = false;

    });
  }




  YakeenMobileNoVerify() {
  
    var req={
      Insured_IdNo:this.fgObj.IqamaNo,
      MobileNo:this.objmdlVerifyDetailsReq.NewMobileNo,
      USerId:"0"
      }
    //alert("Test");
    this.resendObj.RegNo = sessionStorage.getItem("RegNo");
  
    this.showLoading = true;
    this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(req));
  
    //this.http.post<MotorStatusMdl>(this.url.baseURL + "Registration/ResendOTP", this.resendObj, this.userInfo.getHttpOptions()).toPromise().then((res) => {
    this.http.post<mdlPayloadResponse>(this.url.baseURL + "/Limra/YakeenMobileNoVerifyDisAuth", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((res) => {
      //this.st = res;
  
      //New Line Start
      this.objPayloadResponse = res;
      this.YakeenMobileres = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
      //NewLine End

     if(this.YakeenMobileres.StatusCode=="S"){
      if (this.YakeenMobileres.isOwner == false) {
        this.objmdlVerifyDetailsReq.NewMobileNo = "";
        this.Lng == "ar" ? Swal("Please enter the Mobile Number registered in Absher") : Swal("Please enter the Mobile Number registered in Absher");
        
      }
     }
     else{
      Swal(this.YakeenMobileres.StatusDesc);
     }
      
      this.showLoading = false;
    }, (res) => {
      Swal("Try agian");
      this.showLoading = false;
  
    });
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Login/Login.ts